import React, { Fragment } from 'react';
import { Avatar, Popover, Tooltip } from 'antd';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Image from 'helpers/Image';
import PrivateImage from 'helpers/PrivateImage';
import { configurationPermissionIndices, nonThalesVisitorsPermissionIndices, profile_image_type, reportsPermissionIndices, settingsPermissionIndices, thalesVisitorsPermissionIndices } from 'helpers/constants/constants';

const Sidebar = (props) => {
    const { profileData, closeMobile, collapsed, onToggle } = props;
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const logout = () => {
        localStorage.removeItem('token');
        navigate("/login");
    }

    const showSideBar = (indexArray) => {
        return indexArray.some((item) => {
            const perms = profileData?.data?.resDto[item]?.actionAddReqDto;
            return perms?.isAdd === true || perms?.isEdit === true || perms?.isDelete === true || perms?.isView === true;
        });
    }

    const closeDrawer = () => { if (closeMobile) closeMobile(); };

    const content = (
        <div className='pop-hover-content'>
            <div className='pop-profile' onClick={() => navigate("/profile", { state: { profileData: profileData } })}>
                <p>Profile</p>
                <Image name="profile-right-arrow.svg" />
            </div>
            <hr />
            <div className='pop-logout' onClick={logout}>
                <p>Logout</p>
            </div>
        </div>
    );

    const visitorsRoot = showSideBar(thalesVisitorsPermissionIndices) ? "/visitor" : "/vendors";
    const isVisitorsActive = pathname.startsWith('/visitor') || pathname.startsWith('/visitors') || pathname.startsWith('/vendors');
    const isSettingsActive = pathname.startsWith('/settings') || pathname === '/admin' || pathname === '/roles' || pathname === '/api-configuration';

    const navItems = [
        { to: "/dashboard", icon: "dashboard.svg", label: "Dashboard", show: true, active: pathname === '/' || pathname.startsWith('/dashboard') },
        { to: "/reports", icon: "chart-square.svg", label: "Reports", show: showSideBar(reportsPermissionIndices), active: pathname.startsWith('/reports') },
        { to: "/configuration", icon: "settings.svg", label: "Configuration", show: showSideBar(configurationPermissionIndices), active: pathname.startsWith('/configuration') },
        { to: visitorsRoot, icon: "arrow-up-down.svg", label: "Visitor / Vendors", show: showSideBar([...thalesVisitorsPermissionIndices, ...nonThalesVisitorsPermissionIndices]), active: isVisitorsActive },
        { to: "/settings", icon: "settings-admin.svg", label: "Settings", show: showSideBar(settingsPermissionIndices), active: isSettingsActive },
    ];

    const renderLink = (item) => {
        const link = (
            <NavLink
                to={item.to}
                className={item.active ? 'active' : ''}
                onClick={closeDrawer}
                key={item.to}
            >
                <span className="nav-ic"><Image name={item.icon} /></span>
                <span className="nav-label">{item.label}</span>
            </NavLink>
        );
        return collapsed
            ? <Tooltip placement="right" title={item.label} key={item.to}>{link}</Tooltip>
            : link;
    };

    const roleName = profileData?.data?.roleName;
    const initials = `${profileData?.data?.firstName?.[0] || ''}${profileData?.data?.lastName?.[0] || 'S'}`;

    return (
        <Fragment>
            <div className='sidebar-main'>
                {/* Brand + collapse toggle */}
                <div className='sidebar-head'>
                    <div className="sidebar-brand">
                        <span className="brand-tile"><Image name="ast-logo.png" className="sidebar-logo" /></span>
                        <span className="brand-mark"><Image name="ast-mark.png" /></span>
                    </div>
                    <button className="sidebar-collapse-btn" onClick={onToggle} aria-label="Toggle menu">
                        <Image name={collapsed ? "arrow-right.svg" : "arrow-left.svg"} />
                    </button>
                    {/* Mobile close */}
                    <button className="sidebar-mobile-close" onClick={closeDrawer} aria-label="Close menu">
                        <Image name="closeicon.svg" />
                    </button>
                </div>

                <div className='sidebar-links'>
                    {!collapsed && <span className="sidebar-section-label">Menu</span>}
                    {navItems.filter(i => i.show).map(renderLink)}
                </div>

                <Popover content={content} placement={collapsed ? "right" : "top"}>
                    <div className='profile'>
                        <div className="profile-avatar">
                            {profileData?.data?.profileImageUrl
                                ? <PrivateImage className="sidebar-pic" privateUrl={profileData?.data?.profileImageUrl} imgType={profile_image_type} />
                                : <Avatar size={36}>{initials.toUpperCase()}</Avatar>}
                        </div>
                        <div className="profile-meta">
                            <p><b>{profileData?.data?.firstName} {profileData?.data?.lastName}</b></p>
                            <p>{roleName}</p>
                        </div>
                        <Image className="dote" name="dote.svg" />
                    </div>
                </Popover>
            </div>
        </Fragment>
    )
}

export default Sidebar
